import * as React from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';

import BackgroundShowCommandView from './command_views/BackgroundShowCommandView';

import BackgroundShowCommand from '../../../../../domain/entities/commands/BackgroundShowCommand';

interface Size {
  height: number;
  width: number;
}

interface Props {
  style?: StyleProp<ViewStyle>;
  command: BackgroundShowCommand | null;
  size: Size;
  onAfterRenderBackground: (command: BackgroundShowCommand) => void;
}

const StageSet: React.FunctionComponent<Props> = props => {
  const {style, command, size, onAfterRenderBackground} = props;
  return (
    <View style={style}>
      <BackgroundShowCommandView
        command={command}
        size={size}
        onAfterRenderBackground={onAfterRenderBackground}
      />
    </View>
  );
};

const areEqual = (prevProps: Props, nextProps: Props) => {
  return prevProps.command === nextProps.command;
};

export default React.memo(StageSet, areEqual);
